<!-- Shared button template — rendered in card (web) or fixed bar (iOS native) -->
<ng-template #actionButtons>
  <button
    *ngIf="!isRealtime || isCompleted"
    qai-button
    [class.post-call-button]="controlService?.isEndCallRequestOnProcess"
    [size]="'large'"
    [kind]="controlService?.isEndCallRequestOnProcess ? 'secondary': 'primary'"
    [disabled]="controlService?.isEndCallRequestOnProcess"
    (click)="viewResults()"
  >
    <qai-spinner
      *ngIf="controlService?.isEndCallRequestOnProcess"
      class="post-call-spinner"
      [size]="'xsmall'"
      positionStart/>
    {{'call.VIEW_RESULTS' | transloco}}
  </button>

  <button
    *ngIf="!isCompleted && isRealtime"
    qai-button
    [kind]="'primary'"
    [size]="'large'"
    (click)="controlService?.goBackToAssigment()"
  >
    {{ isPersonalizedCall ? ('call.RETURN_TO_PERSONALIZED_PRACTICE' | transloco) : ('call.RETURN_TO_MY_ASSIGNMENTS' | transloco) }}
  </button>
</ng-template>

<div class="overlay-content">
  <div class="overlay">
    <div class="content">
      <div class="icon" *ngIf="navigatorOnline">
        <img src="assets/icons/check-circle-white.svg" alt="{{'call.CHECK_ALT' | transloco}}">
      </div>
      <div class="title">
        {{ title }}
      </div>
      <ng-container *ngIf="navigatorOnline">
        <p class="sub-title">
          {{ subtitle }}
        </p>
        <div *ngIf="!feedbackSubmitted" class="feedback">
          <p class="rating-text">
            {{ question}}
          </p>
          <div class="rating-icon">
            <p (click)="submitFeedback(true)">
              <quant-button class="thumbs-up" type="button" label="" hierarchy="secondary-gray-dark" size="md"
                iconLeading="assets/icons/thumbs_up.svg"></quant-button>
            </p>
            <p (click)="submitFeedback(false)">
              <quant-button class="thumbs-down" type="button" label="" hierarchy="secondary-gray-dark" size="md"
                iconLeading="assets/icons/thumbs_down.svg"></quant-button>
            </p>
          </div>
        </div>
        <div *ngIf="feedbackSubmitted" class="feedback feedback-submit">
          <img *ngIf="selectedFeedback" class="party-icon" src="assets/icons/partying-face.svg"
            alt="{{'call.PARTY_EMOJI' | transloco}}">
          <p class="feedback-text">{{ thankYouMessage }}</p>
        </div>
      </ng-container>

      <!-- Web: buttons inside the card -->
      <ng-container *ngIf="!isNative">
        <ng-container *ngTemplateOutlet="actionButtons"></ng-container>
      </ng-container>
    </div>
  </div>

  <!-- iOS native: buttons fixed to bottom -->
  <div *ngIf="isNative" class="native-action">
    <div class="native-action-button">
      <ng-container *ngTemplateOutlet="actionButtons"></ng-container>
    </div>
  </div>
</div>

<!-- Error Modals -->
<div class="overlay-modal" *ngIf="controlService?.isNetworkError || controlService?.isEndCallError">
  <div class="modal" *ngIf="controlService?.isNetworkError">
    <p class="info">
      {{'call.HAVING_ISSUES' | transloco}}
    </p>

    <button
      qai-button
      [size]="'large'"
      [kind]="'primary'"
      (click)="clickErrorModalOK()"
    >
      {{'call.OK' | transloco}}
    </button>
  </div>

  <div class="modal" *ngIf="controlService?.isEndCallError && !controlService?.isNetworkError">
    <p class="info">
      {{'call.RESULTS_NOT_GENERATED' | transloco}}
    </p>
    <button
      qai-button
      [kind]="'primary'"
      [size]="'large'"
      (click)="clickErrorModalReturnAssignment()"
    >
      {{'call.RETURN_TO_ASSIGNMENT' | transloco}}
    </button>
  </div>
</div>
